import { DiscountTypeEnum } from 'src/app/enum/discount-type.enum';
import { TunnelData } from '../../tunnel/tunnel-data';
import { KitchenPricing } from './kitchen-configuration-price';
import { Quotation } from '../../quotation/quotation';
import { FidelityCardPointSimulationDto } from 'src/app/services/fidelity/fidelity';

export class KitchenTunnelData extends TunnelData {
  public installationPrice: number;

  public totalProductPrice: number;
  public totalProductPriceWithoutInstallation: number;

  public productPrice: number;
  public productPriceWithoutInstallation: number;

  public appliancePrice: number;
  public appliancePriceWithoutInstallation: number;

  public deliveryPrice: number;
  public deliveryWithoutInstallationPrice: number;

  public totalFundingPrice: number;
  public totalFundingWithoutInstallationPrice: number;

  public projectTotalPrice: number;
  public projectTotalWithoutInstallationPrice: number;

  public durationWithInstallation: number;
  public durationWithoutInstallation: number;

  public mensualityWithInstallation: number;
  public mensualityWithoutInstallation: number;

  public totalFundingCostWithInstallation: number;
  public totalFundingCostWithoutInstallation: number;

  public installationDetail: any;
  public offerTableWithInstallation: any;
  public offerTableWithoutInstallation: any;
  public downPayment: number;

  public detailTable: any;
  public discountValue: DiscountTypeEnum;
  public isLess2Years: boolean;
  public withInstallation: boolean;
  public taegWithInstallation: number;
  public taegWithoutInstallation: number;
  public loadedFromConfig: boolean;

  public mlDataWithInstallation: any;
  public txtAssuranceWithInstallation: string;
  public vacWithInstallation: string;

  public mlDataWithoutInstallation: any;
  public txtAssuranceWithoutInstallation: string;
  public vacWithoutInstallation: string;

  public opportunityNumber: number;

  public bom: any;
  public HBMProjectUUID: string;

  public quotation: Quotation;

  public fidelityCardPoint: FidelityCardPointSimulationDto[] = [];

  public rawConfig: any;
  public configId: string;
  public workbenchProjectUUID: string;
  public workbenchProjectPriceDiscount: number;
  public kitchenPricing: KitchenPricing;
  public workbenchOpportunityNumber: number;

  public fundingWithInstallation: {
    interest: number;
    mlData: any;
    txtAssurance: string;
    vac: string;
    mensuality: number;
    duration: number;
    totalFundingCost: number;
    offerTable: any;
  };

  public fundingWithoutInstallation: {
    interest: number;
    mlData: any;
    txtAssurance: string;
    vac: string;
    mensuality: number;
    duration: number;
    totalFundingCost: number;
    offerTable: any;
  };

  private mapDiscountValueToEnum(value: number): DiscountTypeEnum | undefined {
    switch (value) {
      case 0:
        return DiscountTypeEnum.Discount0;
      case 5:
        return DiscountTypeEnum.Discount5;
      case 10:
        return DiscountTypeEnum.Discount10;
      case 20:
        return DiscountTypeEnum.Discount20;
      default:
        return undefined;
    }
  }

  constructor() {
    super();
    this.init();
  }

  initFromConfig(config: any) {
    if (config === null) {
      return;
    }

    this.isLess2Years = config.isLess2Years !== undefined ? config.isLess2Years : this.isLess2Years;

    this.discountValue =
      config.discount !== undefined ? this.mapDiscountValueToEnum(config.discount) : this.discountValue;

    this.downPayment = config.downPayment !== undefined ? config.downPayment : this.downPayment;

    this.withInstallation = config.withInstallation !== undefined ? config.withInstallation : this.withInstallation;

    this.totalProductPrice = config.withInstallation
      ? config.totalProductPrice !== undefined
        ? config.totalProductPrice
        : this.totalProductPrice
      : config.otherTotalProductPrice !== undefined
        ? config.otherTotalProductPrice
        : this.totalProductPrice;

    this.totalProductPriceWithoutInstallation = !config.withInstallation
      ? config.totalProductPrice !== undefined
        ? config.totalProductPrice
        : this.totalProductPriceWithoutInstallation
      : config.otherTotalProductPrice !== undefined
        ? config.otherTotalProductPrice
        : this.totalProductPriceWithoutInstallation;

    this.productPrice = config.withInstallation
      ? config.productPrice !== undefined
        ? config.productPrice
        : this.productPrice
      : config.otherProductPrice !== undefined
        ? config.otherProductPrice
        : this.productPrice;

    this.productPriceWithoutInstallation = !config.withInstallation
      ? config.productPrice !== undefined
        ? config.productPrice
        : this.productPriceWithoutInstallation
      : config.otherProductPrice !== undefined
        ? config.otherProductPrice
        : this.productPriceWithoutInstallation;

    this.appliancePrice = config.withInstallation
      ? config.appliancePrice !== undefined
        ? config.appliancePrice
        : this.appliancePrice
      : config.otherAppliancePrice !== undefined
        ? config.otherAppliancePrice
        : this.appliancePrice;

    this.appliancePriceWithoutInstallation = !config.withInstallation
      ? config.appliancePrice !== undefined
        ? config.appliancePrice
        : this.appliancePriceWithoutInstallation
      : config.otherAppliancePrice !== undefined
        ? config.otherAppliancePrice
        : this.appliancePriceWithoutInstallation;

    this.detailTable =
      config.installationDetail !== undefined ? JSON.parse(config.installationDetail) : this.detailTable;

    this.installationPrice = config.installationPrice !== undefined ? config.installationPrice : this.installationPrice;

    this.offerTableWithInstallation = config.withInstallation
      ? config.offers !== undefined
        ? JSON.parse(config.offers)
        : this.offerTableWithInstallation
      : config.otherOffers !== undefined
        ? JSON.parse(config.otherOffers)
        : this.offerTableWithInstallation;

    this.offerTableWithoutInstallation = !config.withInstallation
      ? config.offers !== undefined
        ? JSON.parse(config.offers)
        : this.offerTableWithoutInstallation
      : config.otherOffers !== undefined
        ? JSON.parse(config.otherOffers)
        : this.offerTableWithoutInstallation;

    this.projectTotalPrice = config.withInstallation
      ? config.montantTotal !== undefined
        ? config.montantTotal
        : this.projectTotalPrice
      : config.otherMontantTotal !== undefined
        ? config.otherMontantTotal
        : this.projectTotalPrice;

    this.projectTotalWithoutInstallationPrice = !config.withInstallation
      ? config.montantTotal !== undefined
        ? config.montantTotal
        : this.projectTotalWithoutInstallationPrice
      : config.otherMontantTotal !== undefined
        ? config.otherMontantTotal
        : this.projectTotalWithoutInstallationPrice;

    this.totalFundingCostWithInstallation =
      config.interestWithInstallation ??
      this.projectTotalPrice - this.mensualityWithInstallation * this.durationWithInstallation;

    this.totalFundingCostWithoutInstallation =
      config.interestWithoutInstallation ??
      this.projectTotalWithoutInstallationPrice - this.mensualityWithoutInstallation * this.durationWithoutInstallation;

    this.mlDataWithInstallation = config.withInstallation
      ? config.mlData !== undefined
        ? JSON.parse(config.mlData)
        : this.mlDataWithInstallation
      : config.otherMlData !== undefined
        ? JSON.parse(config.otherMlData)
        : this.mlDataWithInstallation;

    this.txtAssuranceWithInstallation =
      config.txtAssuranceWithInstallation !== undefined
        ? config.txtAssuranceWithInstallation
        : this.txtAssuranceWithInstallation;

    this.vacWithInstallation =
      config.vacWithInstallation !== undefined ? config.vacWithInstallation : this.vacWithInstallation;

    this.mlDataWithoutInstallation = !config.withInstallation
      ? config.mlData !== undefined
        ? JSON.parse(config.mlData)
        : this.mlDataWithoutInstallation
      : config.otherMlData !== undefined
        ? JSON.parse(config.otherMlData)
        : this.mlDataWithoutInstallation;

    this.txtAssuranceWithoutInstallation =
      config.txtAssuranceWithoutInstallation !== undefined
        ? config.txtAssuranceWithoutInstallation
        : this.txtAssuranceWithoutInstallation;

    this.vacWithoutInstallation =
      config.vacWithoutInstallation !== undefined ? config.vacWithoutInstallation : this.vacWithoutInstallation;

    this.opportunityNumber = config.opportunityNumber;
    this.loadedFromConfig = true;

    if (config.bom) {
      this.bom = JSON.parse(config.bom);
    }
    this.rawConfig = config;
    this.configId = config.id;
    this.workbenchProjectUUID = config.workbenchProjectUUID;
    this.workbenchOpportunityNumber = config.workbenchOpportunityNumber;

    this.durationWithInstallation = config.withInstallation
      ? config.duration !== undefined
        ? config.duration
        : this.durationWithInstallation
      : config.otherDuration !== undefined
        ? config.otherDuration
        : this.durationWithInstallation;

    this.durationWithoutInstallation = !config.withInstallation
      ? config.duration !== undefined
        ? config.duration
        : this.durationWithoutInstallation
      : config.otherDuration !== undefined
        ? config.otherDuration
        : this.durationWithoutInstallation;

    this.mensualityWithInstallation = config.withInstallation
      ? config.mensuality !== undefined
        ? config.mensuality
        : this.mensualityWithInstallation
      : config.otherMensuality !== undefined
        ? config.otherMensuality
        : this.mensualityWithInstallation;

    this.mensualityWithoutInstallation = !config.withInstallation
      ? config.mensuality !== undefined
        ? config.mensuality
        : this.mensualityWithoutInstallation
      : config.otherMensuality !== undefined
        ? config.otherMensuality
        : this.mensualityWithoutInstallation;

    this.fundingWithoutInstallation = {
      interest:
        config.interestWithoutInstallation ??
        this.projectTotalWithoutInstallationPrice -
          this.mensualityWithoutInstallation * this.durationWithoutInstallation,
      mlData: !config.withInstallation
        ? config.mlData !== undefined
          ? JSON.parse(config.mlData)
          : this.mlDataWithoutInstallation
        : config.otherMlData !== undefined
          ? JSON.parse(config.otherMlData)
          : this.mlDataWithoutInstallation,
      txtAssurance:
        config.txtAssuranceWithoutInstallation !== undefined
          ? config.txtAssuranceWithoutInstallation
          : this.txtAssuranceWithoutInstallation,
      vac: config.vacWithoutInstallation !== undefined ? config.vacWithoutInstallation : this.vacWithoutInstallation,
      mensuality: !config.withInstallation
        ? config.mensuality !== undefined
          ? config.mensuality
          : this.mensualityWithoutInstallation
        : config.otherMensuality !== undefined
          ? config.otherMensuality
          : this.mensualityWithoutInstallation,
      duration: !config.withInstallation
        ? config.duration !== undefined
          ? config.duration
          : this.durationWithoutInstallation
        : config.otherDuration !== undefined
          ? config.otherDuration
          : this.durationWithoutInstallation,
      totalFundingCost: undefined,
      offerTable: !config.withInstallation
        ? config.offers !== undefined
          ? JSON.parse(config.offers)
          : this.offerTableWithoutInstallation
        : config.otherOffers !== undefined
          ? JSON.parse(config.otherOffers)
          : this.offerTableWithoutInstallation,
    };
    this.fundingWithInstallation = {
      interest:
        config.interestWithInstallation ??
        this.projectTotalPrice - this.mensualityWithInstallation * this.durationWithInstallation,
      mlData: config.withInstallation
        ? config.mlData !== undefined
          ? JSON.parse(config.mlData)
          : this.mlDataWithInstallation
        : config.otherMlData !== undefined
          ? JSON.parse(config.otherMlData)
          : this.mlDataWithInstallation,
      txtAssurance:
        config.txtAssuranceWithInstallation !== undefined
          ? config.txtAssuranceWithInstallation
          : this.txtAssuranceWithInstallation,
      vac: config.vacWithInstallation !== undefined ? config.vacWithInstallation : this.vacWithInstallation,
      mensuality: config.withInstallation
        ? config.mensuality !== undefined
          ? config.mensuality
          : this.mensualityWithInstallation
        : config.otherMensuality !== undefined
          ? config.otherMensuality
          : this.mensualityWithInstallation,
      duration: config.withInstallation
        ? config.duration !== undefined
          ? config.duration
          : this.durationWithInstallation
        : config.otherDuration !== undefined
          ? config.otherDuration
          : this.durationWithInstallation,
      totalFundingCost: undefined,
      offerTable: config.withInstallation
        ? config.offers !== undefined
          ? JSON.parse(config.offers)
          : this.offerTableWithInstallation
        : config.otherOffers !== undefined
          ? JSON.parse(config.otherOffers)
          : this.offerTableWithInstallation,
    };
  }

  init() {
    this.installationPrice = 0;
    this.productPrice = 0;
    this.totalProductPrice = 0;
    this.totalProductPriceWithoutInstallation = 0;
    this.appliancePrice = 0;
    this.deliveryPrice = 0;
    this.deliveryWithoutInstallationPrice = 0;
    this.productPriceWithoutInstallation = 0;
    this.appliancePriceWithoutInstallation = 0;
    this.totalFundingPrice = 0;
    this.totalFundingWithoutInstallationPrice = 0;
    this.projectTotalPrice = 0;
    this.projectTotalWithoutInstallationPrice = 0;
    this.durationWithInstallation = 0;
    this.mensualityWithInstallation = 0;
    this.totalFundingCostWithInstallation = 0;
    this.durationWithoutInstallation = 0;
    this.mensualityWithoutInstallation = 0;
    this.totalFundingCostWithoutInstallation = 0;
    this.installationDetail = undefined;
    this.offerTableWithInstallation = undefined;
    this.offerTableWithoutInstallation = undefined;
    this.detailTable = undefined;
    this.isLess2Years = undefined;
    this.withInstallation = undefined;
    this.taegWithInstallation = 0.0;
    this.taegWithoutInstallation = 0.0;
    this.loadedFromConfig = false;
    this.mlDataWithInstallation = undefined;
    this.mlDataWithoutInstallation = undefined;
    this.opportunityNumber = 0;
    this.bom = undefined;
    this.HBMProjectUUID = undefined;
    this.rawConfig = undefined;
    this.configId = undefined;
    this.workbenchProjectUUID = undefined;
    this.downPayment = 0;
    this.txtAssuranceWithInstallation = '';
    this.vacWithInstallation = '';
    this.txtAssuranceWithoutInstallation = '';
    this.vacWithoutInstallation = '';
    this.discountValue = DiscountTypeEnum.Discount0;
    this.fundingWithoutInstallation = {
      interest: undefined,
      mlData: undefined,
      txtAssurance: undefined,
      vac: undefined,
      mensuality: undefined,
      duration: undefined,
      totalFundingCost: undefined,
      offerTable: undefined,
    };
    this.fundingWithInstallation = {
      interest: undefined,
      mlData: undefined,
      txtAssurance: undefined,
      vac: undefined,
      mensuality: undefined,
      duration: undefined,
      totalFundingCost: undefined,
      offerTable: undefined,
    };
  }
}
